import React from "react";
import { Image } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import usercentric from "../../images/user-centric-optimized.jpg";
import SvgIconsSet from "../SvgIconsSet";

const CardDetail = [
  {
    cardTitle: "Strategy & Design",
    src: usercentric,
    alt: "Strategy & Design",
    cardDescription:
      "Our experienced team can help you test the feasibility of your idea right from the start with Proof of Concept (PoC) and Minimum Viable Products (MVP) design and build services.",
  },

  {
    cardTitle: "Build & Engineer",
    src: usercentric,
    alt: "Build & Engineer",
    cardDescription:
      "From new product development to digital transformation, we create bespoke solutions that solve real business problems.",
  },

  {
    cardTitle: "Managed Services & Resources",
    src: usercentric,
    alt: "Managed Services & Resources",
    cardDescription:
      "Our teams have been trusted by hundreds of organisations to provide high quality managed IT support services and highly experienced resources to increase capacity as required.",
  },
];

const Sfsolution = () => {
  return (
    <div className="software-solution">
      <div className="section-top">
        <div className="title-1 pb-6">
          Agile, innovative and impactful software engineering solutions
        </div>
        <div className="section-discription">
          Our extensive team of software engineers, designers and developers
          gives you access to the right skills and experience needed to deliver
          real business impact and cost efficiencies. Smart design, agile
          delivery and vendor management is in our DNA, ensuring exceptional
          outcomes for you - every time.
        </div>
      </div>

      <div className="wrap-card-software-solution">
        {CardDetail.map((solution) => (
          <Card className="card-software-solution">
            <div className="card-software-solution-img-top">
              <Image src={solution.src} alt={solution.alt} />
            </div>
            <CardBody>
              <div class="card-title">{solution.cardTitle}</div>
              <p class="card-text">{solution.cardDescription}</p>
              <a href="#" class="btn btn-primary btn-icon-button">
                <span className="btn-text">Learn more</span>
                <span className="btn-icon">
                  <SvgIconsSet.SideArrow />
                </span>
              </a>
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Sfsolution;
